import { RootState } from "../store";

export const userSelector = (state: RootState) => state.auth.user;
export const jwtSelector = (state: RootState) => state.auth.jwt;
